import {
  makeAutoObservable,
  observable,
  action,
  computed,
  runInAction,
  toJS,
  autorun,
  onBecomeUnobserved,
  reaction,
} from "mobx";
import { commonAxios } from "../../pages/ExperianPage/CommonAxios";
class DynamicTableStore {
  constructor(rootstore) {
    this.rootstore = rootstore;
    makeAutoObservable(this);
  }
  formatValue = (value) => {
    // Handle falsy values (null, undefined, empty string, etc.)
    if (!value && value !== 0) {
      return "-";
    }
    // 1. Handle numbers or numeric strings
    if (!isNaN(value) && value !== null && value !== "") {
      return Number(value);
    }
    // 2. Handle ISO date string
    const isoDateRegex = /^\d{4}-\d{2}-\d{2}T/;
    if (typeof value === "string" && isoDateRegex.test(value)) {
      const date = new Date(value);
      const options = { day: "2-digit", month: "long", year: "numeric" };
      return date.toLocaleDateString("en-US", options); // e.g., "07, June 2025"
    }
    // 3. Handle strings like camelCase, PascalCase, snake_case, etc.
    if (typeof value === "string") {
      return value
        .replace(/_/g, " ") // snake_case -> space
        .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase -> space
        .replace(/\s+/g, " ") // remove extra spaces
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize words
    }
    return value; // fallback
  };
}
export default DynamicTableStore;
